(function () {
  const ZOOM_SCALE = 2;
  const MEDIA_SELECTOR = ".product-media-container";

  function createModal() {
    if (document.getElementById("zoom-modal")) return;

    const overlay = document.createElement("div");
    overlay.id = "zoom-modal";
    Object.assign(overlay.style, {
      position: "fixed",
      inset: "0",
      background: "#fff",
      zIndex: "99999",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      opacity: "0",
      transition: "opacity 0.3s ease",
      pointerEvents: "none",
      overflow: "hidden",
    });

    const imgWrapper = document.createElement("div");
    imgWrapper.id = "zoom-modal-img-wrapper";
    Object.assign(imgWrapper.style, {
      position: "relative",
      width: "90vw",
      height: "90vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      overflow: "hidden",
      cursor: "zoom-in",
    });

    const img = document.createElement("img");
    img.id = "zoom-modal-img";
    Object.assign(img.style, {
      maxWidth: "90vw",
      maxHeight: "90vh",
      objectFit: "contain",
      borderRadius: "4px",
      transform: "scale(0.95)",
      transition: "transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
      userSelect: "none",
      WebkitUserDrag: "none",
      transformOrigin: "center center",
      pointerEvents: "none",
    });

    const modalHint = document.createElement("div");
    modalHint.id = "zoom-modal-hint";
    modalHint.textContent = "Click to zoom";
    Object.assign(modalHint.style, {
      position: "absolute",
      bottom: "50%",
      left: "50%",
      transform: "translateX(-50%)",
      background: "rgba(96,109,34,0.7)",
      backdropFilter: "blur(6px)",
      WebkitBackdropFilter: "blur(6px)",
      color: "#fff",
      fontSize: "12px",
      fontWeight: "500",
      letterSpacing: "0.08em",
      textTransform: "uppercase",
      padding: "7px 14px",
      borderRadius: "20px",
      pointerEvents: "none",
      zIndex: "10",
      opacity: "0",
      transition: "opacity 0.6s ease",
      whiteSpace: "nowrap",
    });

    const closeBtn = document.createElement("button");
    closeBtn.id = "zoom-modal-close";
    closeBtn.innerHTML = `
      <span class="patrol-sr-only"> Close </span>
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"
        fill="none" stroke="currentColor" stroke-width="2.5"
        stroke-linecap="round" stroke-linejoin="round">
        <line x1="18" y1="6" x2="6" y2="18"/>
        <line x1="6" y1="6" x2="18" y2="18"/>
      </svg>`;
    Object.assign(closeBtn.style, {
      position: "fixed",
      top: "20px",
      right: "20px",
      width: "40px",
      height: "40px",
      borderRadius: "50%",
      border: "none",
      background: "#f1f1f1",
      color: "#111",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      boxShadow: "0 2px 10px rgba(0,0,0,0.12)",
      transition: "background 0.2s ease, transform 0.2s ease",
      zIndex: "100000",
    });

    closeBtn.addEventListener("mouseenter", () => {
      closeBtn.style.background = "#e0e0e0";
      closeBtn.style.transform = "scale(1.1)";
    });
    closeBtn.addEventListener("mouseleave", () => {
      closeBtn.style.background = "#f1f1f1";
      closeBtn.style.transform = "scale(1)";
    });

    imgWrapper.appendChild(img);
    imgWrapper.appendChild(modalHint);
    overlay.appendChild(imgWrapper);
    overlay.appendChild(closeBtn);
    document.body.appendChild(overlay);

    let isModalZoomed = false;
    let hintTimer = null;

    function showModalHint() {
      if (hintTimer) clearTimeout(hintTimer);
      modalHint.style.opacity = "1";
      hintTimer = setTimeout(() => {
        modalHint.style.opacity = "0";
      }, 5000);
    }

    function closeModal() {
      overlay.style.opacity = "0";
      img.style.transform = "scale(0.95)";
      img.style.transition =
        "transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)";
      isModalZoomed = false;
      img.style.transformOrigin = "center center";
      imgWrapper.style.cursor = "zoom-in";
      modalHint.style.opacity = "0";
      if (hintTimer) clearTimeout(hintTimer);
      setTimeout(() => {
        overlay.style.pointerEvents = "none";
        document.body.style.overflow = "";
      }, 300);
    }

    const isTouchDevice = window.matchMedia("(hover: none)").matches;

    if (!isTouchDevice) {
      imgWrapper.addEventListener("click", (e) => {
        isModalZoomed = !isModalZoomed;

        if (isModalZoomed) {
          const rect = imgWrapper.getBoundingClientRect();
          const x = ((e.clientX - rect.left) / rect.width) * 100;
          const y = ((e.clientY - rect.top) / rect.height) * 100;
          img.style.transformOrigin = `${x}% ${y}%`;
          img.style.transition =
            "transform 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94)";
          img.style.transform = `scale(${ZOOM_SCALE})`;
          imgWrapper.style.cursor = "zoom-out";
          modalHint.style.opacity = "0";
          if (hintTimer) clearTimeout(hintTimer);
        } else {
          img.style.transition =
            "transform 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94)";
          img.style.transform = "scale(1)";
          img.style.transformOrigin = "center center";
          imgWrapper.style.cursor = "zoom-in";
          showModalHint();
        }
      });

      imgWrapper.addEventListener("mousemove", (e) => {
        if (!isModalZoomed) return;
        const rect = imgWrapper.getBoundingClientRect();
        const x = ((e.clientX - rect.left) / rect.width) * 100;
        const y = ((e.clientY - rect.top) / rect.height) * 100;
        img.style.transition = "transform-origin 0.1s ease";
        img.style.transformOrigin = `${x}% ${y}%`;
      });
    }

    closeBtn.addEventListener("click", closeModal);
    overlay.addEventListener("click", (e) => {
      if (e.target === overlay) closeModal();
    });
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") closeModal();
    });

    overlay._showHint = showModalHint;
    overlay._resetZoom = () => {
      isModalZoomed = false;
      img.style.transition = "none";
      img.style.transform = "scale(1)";
      img.style.transformOrigin = "center center";
      imgWrapper.style.cursor = "zoom-in";
    };
  }

  function openModal(src) {
    const overlay = document.getElementById("zoom-modal");
    const img = document.getElementById("zoom-modal-img");
    if (!overlay || !img) return;

    if (overlay._resetZoom) overlay._resetZoom();

    img.src = src;
    overlay.style.pointerEvents = "all";
    document.body.style.overflow = "hidden";

    requestAnimationFrame(() => {
      overlay.style.opacity = "1";
      img.style.transition =
        "transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)";
      img.style.transform = "scale(1)";

      const isTouchDevice = window.matchMedia("(hover: none)").matches;
      if (!isTouchDevice && overlay._showHint) overlay._showHint();
    });
  }

  function createZoomHint(wrapper, isTouchDevice) {
    const hint = document.createElement("div");
    hint.textContent = isTouchDevice ? "Tap to zoom" : "Hover to zoom";
    Object.assign(hint.style, {
      position: "absolute",
      bottom: "50%",
      left: "50%",
      transform: "translateX(-50%)",
      background: "rgba(96,109,34,0.7)",
      backdropFilter: "blur(6px)",
      WebkitBackdropFilter: "blur(6px)",
      color: "#fff",
      fontSize: "12px",
      fontWeight: "500",
      letterSpacing: "0.08em",
      textTransform: "uppercase",
      padding: "15px",
      borderRadius: "20px",
      pointerEvents: "none",
      zIndex: "10",
      opacity: "1",
      transition: "opacity 0.6s ease",
      whiteSpace: "nowrap",
    });

    const pos = getComputedStyle(wrapper).position;
    if (pos === "static") wrapper.style.position = "relative";
    wrapper.appendChild(hint);

    setTimeout(() => {
      hint.style.opacity = "0";
      setTimeout(() => hint.remove(), 700);
    }, 5000);
  }

  function initZoom(wrapper) {
    const zoomTarget = wrapper.querySelector(".product__media");
    const imgEl = wrapper.querySelector("img");
    if (!zoomTarget || !imgEl) return;

    const isTouchDevice = window.matchMedia("(hover: none)").matches;
    createZoomHint(wrapper, isTouchDevice);

    wrapper.style.overflow = "hidden";
    zoomTarget.style.willChange = "transform";

    /* ───────────────── DESKTOP ───────────────── */
    if (!isTouchDevice) {
      let isHovering = false;

      wrapper.style.cursor = "zoom-in";

      wrapper.addEventListener("click", (e) => {
        e.preventDefault();
        openModal(imgEl.src);
      });

      wrapper.addEventListener("mouseenter", () => {
        isHovering = true;
        zoomTarget.style.transition = "transform 0.3s ease";
        zoomTarget.style.transform = `scale(${ZOOM_SCALE})`;
        wrapper.style.cursor = "zoom-in";
      });

      wrapper.addEventListener("mousemove", (e) => {
        if (!isHovering) return;
        const rect = wrapper.getBoundingClientRect();
        const x = ((e.clientX - rect.left) / rect.width) * 100;
        const y = ((e.clientY - rect.top) / rect.height) * 100;
        zoomTarget.style.transition = "none";
        zoomTarget.style.transformOrigin = `${x}% ${y}%`;
      });

      wrapper.addEventListener("mouseleave", () => {
        isHovering = false;
        zoomTarget.style.transition = "transform 0.3s ease";
        zoomTarget.style.transform = "scale(1)";
        zoomTarget.style.transformOrigin = "center center";
        wrapper.style.cursor = "zoom-in";
      });
    }

    /* ───────────────── MOBILE ───────────────── */
    if (isTouchDevice) {
      let isZoomed = false;
      let isDragging = false;
      let currentX = 0;
      let currentY = 0;
      let lastX = 0;
      let lastY = 0;
      let velX = 0;
      let velY = 0;
      let rafId = null;

      const FRICTION = 0.92;

      function momentum() {
        velX *= FRICTION;
        velY *= FRICTION;
        currentX += velX;
        currentY += velY;
        zoomTarget.style.transform = `translate3d(${currentX}px, ${currentY}px, 0) scale(${ZOOM_SCALE})`;

        if (Math.abs(velX) > 0.3 || Math.abs(velY) > 0.3) {
          rafId = requestAnimationFrame(momentum);
        }
      }

      wrapper.addEventListener("click", (e) => {
        e.preventDefault();
        isZoomed = !isZoomed;

        if (rafId) cancelAnimationFrame(rafId);

        if (isZoomed) {
          zoomTarget.style.transition = "transform 0.35s ease";
          zoomTarget.style.transform = `translate3d(${currentX}px, ${currentY}px, 0) scale(${ZOOM_SCALE})`;
        } else {
          currentX = 0;
          currentY = 0;
          velX = 0;
          velY = 0;
          zoomTarget.style.transition = "transform 0.35s ease";
          zoomTarget.style.transform = "translate3d(0,0,0) scale(1)";
        }
      });

      wrapper.addEventListener("touchstart", (e) => {
        if (!isZoomed) return;
        if (rafId) cancelAnimationFrame(rafId);

        isDragging = true;
        velX = 0;
        velY = 0;
        lastX = e.touches[0].clientX;
        lastY = e.touches[0].clientY;
        zoomTarget.style.transition = "none";
      });

      wrapper.addEventListener(
        "touchmove",
        (e) => {
          if (!isDragging || !isZoomed) return;

          e.preventDefault();

          const moveX = e.touches[0].clientX;
          const moveY = e.touches[0].clientY;

          const deltaX = moveX - lastX;
          const deltaY = moveY - lastY;

          velX = deltaX;
          velY = deltaY;

          currentX += deltaX;
          currentY += deltaY;

          lastX = moveX;
          lastY = moveY;

          zoomTarget.style.transform = `translate3d(${currentX}px, ${currentY}px, 0) scale(${ZOOM_SCALE})`;
        },
        { passive: false },
      );

      wrapper.addEventListener("touchend", () => {
        if (!isDragging) return;
        isDragging = false;
        rafId = requestAnimationFrame(momentum);
      });

      wrapper.addEventListener("touchcancel", () => {
        isDragging = false;
        velX = 0;
        velY = 0;
      });
    }
  }

  function initAllZooms() {
    createModal();
    document.querySelectorAll(MEDIA_SELECTOR).forEach(initZoom);
  }

  document.addEventListener("DOMContentLoaded", initAllZooms);
})();
